<template>
    <div>
        <!-- Table -->
        <b-table
            id="teachersTable"
            :items="table"
            :fields="fields"
            empty-text="Não encontramos nenhum resultado na busca :("
            class="bg-white mb-0"
            stacked="md"
            :sticky-header="true"
            show-empty
            bordered
            hover>

            <template v-slot:cell(price)="row">
                {{ row.item.price | currency('R$ ', 2, { decimalSeparator: ',' }) }}
            </template>

            <template v-slot:cell(price_unit)="row">
                <div v-for="item in row.item.price_unit" class="block">
                    {{ item.count }} x {{ item.price | currency('R$ ', 2, { decimalSeparator: ',' }) }} = {{ item.total_price | currency('R$ ', 2, { decimalSeparator: ',' }) }}
                </div>
            </template>

        </b-table>
    </div>
</template>

<script>
export default {
    props: {
        table: {
            type: Array,
            default: []
        },
        qtdLabel: {
            type: String,
            default: 'Qtd. Redações Corrigidas'
        }
    },
    data() {
        return {
            fields: [
                { key: 'name', label: 'Professor', sortable: true },
                { key: 'qtd', label: this.qtdLabel, sortable: true },
                { key: 'price_unit', label: 'Valor Detalhado', sortable: false },
                { key: 'price', label: 'Valor Total', sortable: true },
            ],
        }
    }
}
</script>

<style scoped>

</style>
